export default __webpack_public_path__ + "i18n/translations/translation-da.3e495534.json";